import Apod from './apod';

export default Apod;